import React, { useEffect, useMemo } from 'react';
import get from 'lodash/get';
import lowerCase from 'lodash/lowerCase';
import { Select, Typography, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import enImg from '@assets/img/EN.png';
import ruImg from '@assets/img/RU.png';

const { Title, Paragraph, Text } = Typography;

export default function SetupBegin({ initialValues, onDone }) {
  const { i18n, t } = useTranslation();

  const defaultLang = useMemo(() => lowerCase(get(initialValues, 'language')), [
    initialValues,
  ]);

  const handleChangeLanguage = (locale) => {
    i18n.changeLanguage(locale);
    moment.locale(locale, {
      week: {
        dow: 1,
        doy: 1,
      },
    });
  };

  useEffect(() => {
    handleChangeLanguage(defaultLang);
  }, [defaultLang]);

  return (
    <div className="setup-begin">
      <Paragraph className="setup-begin__desc">
        {t('setup-begin-desc-top')}
        <br />
        {t('setup-begin-desc-bottom')}
      </Paragraph>
      <div className="setup-begin__lang">
        {t('setup-begin-lang')}:
        <Select
          defaultValue={defaultLang}
          style={{ width: 156 }}
          onChange={handleChangeLanguage}
        >
          <Select.Option value="en">
            <img
              src={enImg}
              alt="English"
              className="settings-basic__lang-icon"
            />
            English
          </Select.Option>
          <Select.Option value="ru">
            <img
              src={ruImg}
              alt="Russian"
              className="settings-basic__lang-icon"
            />
            Русский
          </Select.Option>
        </Select>
      </div>
      <div className="setup-begin__action">
        <Button type="primary" size="large" onClick={onDone}>
          {t('setup-begin-start-setup')}
        </Button>
      </div>
    </div>
  );
}
